__turbopack_context__.v({
  "Caption": "Gallery-module-sass-module__uBp72G__Caption",
  "Cont": "Gallery-module-sass-module__uBp72G__Cont",
  "Controls": "Gallery-module-sass-module__uBp72G__Controls",
  "Gallery": "Gallery-module-sass-module__uBp72G__Gallery",
  "Image": "Gallery-module-sass-module__uBp72G__Image",
  "Main": "Gallery-module-sass-module__uBp72G__Main",
});
